if (!document.body.classList.contains("neos-backend")) {
    class FlyingFocus {
        constructor() {
            this.DURATION = 150;

            this.ringElem = null;
            this.root = document.body;
            this.target = null;
            this.movingId = 0;
            this.prevFocused = null;
            this.keyDownTime = 0;
            this.activator = null;

            document.documentElement.addEventListener(
                "keydown",
                (event) => {
                    var code = event.which;
                    // Show animation only upon Tab or Arrow keys press.
                    if (code === 9 || (code > 36 && code < 41)) {
                        this.keyDownTime = Date.now();
                        this.activator = "key";
                    }
                },
                false
            );

            document.documentElement.addEventListener(
                "mousedown",
                () => {
                    this.ringElem?.classList.remove("flying-focus_visible");
                    this.activator = "mouse";
                },
                false
            );

            document.documentElement.addEventListener(
                "focus",
                (event) => {
                    this.target = event.target;
                    if (this.target.id === "flying-focus") {
                        return;
                    }

                    this.root = this.target.closest("dialog, body");

                    var isFirstFocus = false;
                    if (!this.ringElem) {
                        isFirstFocus = true;
                        this.initialize();
                    } else {
                        this.moveToRoot();
                    }

                    this.updatePosition(this.target);

                    if (isFirstFocus) return;
                    if (!this.isJustPressed()) {
                        this.onEnd();
                        return;
                    }
                    this.target.classList.add("flying-focus_target");
                    this.ringElem.classList.add("flying-focus_visible");
                    this.prevFocused = this.target;
                },
                true
            );

            document.documentElement.addEventListener(
                "blur",
                () => {
                    this.onEnd(true);
                },
                true
            );
        }

        initialize() {
            this.ringElem = document.createElement("flying-focus"); // use uniq element name to decrease the chances of a conflict with website styles
            if (this.activator === "key") {
                this.ringElem.className = "flying-focus_visible";
            }
            this.ringElem.style.transitionDuration = this.ringElem.style.WebkitTransitionDuration =
                this.DURATION / 1000 + "s";
            this.root.appendChild(this.ringElem);
        }

        moveToRoot() {
            this.root.appendChild(this.ringElem);
        }

        onEnd(trueEnd = false) {
            if (trueEnd && !this.movingId) {
                return;
            }
            if (this.movingId) {
                clearTimeout(this.movingId);
                this.movingId = 0;
            }
            if (this.root === document.activeElement) {
                this.ringElem.classList.remove("flying-focus_visible");
            }
            if (this.prevFocused) {
                this.prevFocused.classList.remove("flying-focus_target");
                this.prevFocused = null;
            }
        }

        isJustPressed() {
            return Date.now() - this.keyDownTime < 42;
        }

        updatePosition(target) {
            var rect = target.getBoundingClientRect();
            var clientLeft = document.documentElement.clientLeft || document.body.clientLeft;
            var clientTop = document.documentElement.clientTop || document.body.clientTop;
            var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            var left = rect.left + scrollLeft - clientLeft;
            var top = rect.top + scrollTop - clientTop;
            if (this.root !== document.body) {
                const rootRect = this.root.getBoundingClientRect();
                top -= rootRect.top;
                left -= rootRect.left;
            }
            this.ringElem.style.left = left + "px";
            this.ringElem.style.top = top + "px";
            this.ringElem.style.width = target.offsetWidth + "px";
            this.ringElem.style.height = target.offsetHeight + "px";
        }
    }
    window.FlyingFocus = new FlyingFocus();
}
